/* eslint-disable  */
/* eslint-disable no-unused-vars */
import { useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import moment from 'moment';
import { Download, Visibility } from '@mui/icons-material';
import { Button, Chip, Tooltip } from '@mui/material';
import { connect } from 'react-redux';
import SelectPicker from 'rsuite/SelectPicker';
import ImagesFinder from '../../Components/ImagesFinder/ImagesFinder';
import { ListTable } from '../../Components/ListTable';
import styles from './PettyCash.module.scss';
import { urls } from '../../Constants';
import financialTransactionsServices from '../../Services/Analytics Services/financial-transactions.services';
import inventoryAnalyticsServices from '../../Services/Analytics Services/inventory-analytics.services';
import { notificationServices } from '../../Services';
import { POItemsModal } from '../../Components/Modals/POItemsModal';
import { formActions, modalActions } from '../../Actions';
import { BackdropLoader } from '../../Components/Loaders';
import { filtersInfoChip, getActionColumn, getFileName, handleExcelDownload } from '../../Helpers';
import useSearchFilters from '../../Helpers/useSearchFilters';
import userRolesAndPermissions from '@/Services/userRolesAndPermissions.services';
import { useAuth } from '@/Components/Auth/Login/auth';
import authActions from '@/Actions/auth.actions';
import { Filter, RefreshCcw } from 'lucide-react';
import drawerActions from '@/Actions/drawer.actions';
import GlobalSearch from '@/Components/globalSearch/search';

const statusList = [
	{
		id: 'CANCELLED',
		title: 'CANCELLED',
	},
	{
		id: 'REJECTED',
		title: 'REJECTED',
	},
	{
		id: 'PAID',
		title: 'PAID',
	},
	{
		id: 'UNPAID',
		title: 'UNPAID',
	},
	{
		id: 'PARTIALLY_PAID',
		title: 'PARTIALLY PAID',
	},
	{
		id: 'APPROVAL_PENDING_MANAGER',
		title: 'APPROVAL PENDING MANAGER',
	},
	{
		id: 'APPROVAL_PENDING_FINANCE',
		title: 'APPROVAL PENDING FINANCE',
	}
];

const timeTypeArr = [
	{
		label: 'Created At',
		value: 'createdAt',
	},
	{
		label: 'Bill Date',
		value: 'transactionDate',
		disabledFutureDate: true,
	},
	{
		label: 'Due Date',
		value: 'dueDate',
	},
];

const TABLE_COLUMNS = [
	{
		title: 'ID',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Payment Type',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Store',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Category',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Payment Mode',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Vendor',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Client Transaction Id',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Status',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Created By',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Created At',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Payment By',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Transaction Date',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Due Date',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'L1 Action By',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'L2 Action By',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Expense Sub Total',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Expense tax slab',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Expense tax amount',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Expense Total',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Income Total',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Ref. Number',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Reference doc',
		config: {
			type: 'DATA',
		},
	},
];

const BASE_COLUMN = [
	{
		title: 'View',
		config: {
			type: 'VIEW',
		},
	},
];

const ADDITIONAL_COLUMN = [
	{
		title: 'Actions',
		config: {
			type: 'DATA',
		},
	},
];

const COLMAP = {
	ID: 'id',
	'Payment Type': 'extraData',
	Vendor: 'vendorName',
	Store: 'storeName',
	Category: 'category',
	Status: 'transactionStatus',
	'Created By': 'initiatedByUserDisplayName',
	'Created At': 'createdAt',
	'Client Transaction Id': 'clientTransactionId',
	'Transaction Date': 'transactionDate',
	'Due Date': 'dueDate',
	'L1 Action By': 'l1ActionByUserDisplayName',
	'L2 Action By': 'l2ActionByUserDisplayName',
	'Payment Mode': 'extraData',
	'Expense tax slab': 'id',
	'Expense tax amount': 'id',
	'Expense Sub Total': 'id',
	'Expense Total': 'id',
	'Income Total': 'id',
	'Payment By': 'id',
	'Ref. Number': 'extraData',
	'Reference doc': 'uploadedDoc',
};

const searchQueries = [
	{
		id: 'transactionId',
		type: 'billId',
		generateTitle: (exlusiveKey) => {
			return `Id: ${exlusiveKey}`;
		},
		removable: true,
		exclusiveKey: 'clientTransactionId',
		dependentKey: '',
	},
];

const PettyCash = (props) => {
	const {
		togglePOItemsModal,
		navState,
		toggleAlert,
		stores,
		vendorsList,
		fetchAllVendors,
		fetchStoresList,
		toggleFiltersDrawer,
	} = props;
	const history = useHistory();
	const { userConfig = {} } = useAuth();
	const { level } = userConfig?.userDetails || {};
	const levels = [3, 4];
	const { userRolesDict } = userConfig || {};
	const isInternal = Object?.values?.(userRolesDict ?? {}).includes('INTERNAL') || Object?.values?.(userRolesDict ?? {}).includes('CXO Office');
	const [pettyCashList, setPettyCashList] = useState([]);
	const [update, setUpdate] = useState(-1);
	const [isLoading, setIsLoading] = useState(false);
	const [subType, setSubtype] = useState('ALL');
	const [isRefresh, setIsRefresh] = useState(false);
	const [search, setSearch] = useState('');
	const navRequisites = navState?.[urls.PURCHASE_ORDERS]?.requisites ?? [];
	const navSelectedStore = navRequisites?.find((ele) => {
		return ele?.type === 'store';
	});
	const [filters, setFilters] = useState({});

	const { searchFilters } = useSearchFilters({
		searchQueries,
		callBackFn: () => {
			setUpdate((prev) => {
				return prev + 1;
			});
		},
	});

	useEffect(() => {
		fetchAllVendors({
			entity: 'ALL_VENDORS',
			req: {
				params: {
					id: '',
				},
			},
			method: 'LIST',
		});
		fetchStoresList({
			entity: 'STORES',
			req: {
				params: {
					id: '',
					type: '',
				},
			},
			method: 'LIST',
		});
	}, []);

	const storeIdMap = useMemo(() => {
		const map = {};
		stores?.forEach((ele) => {
			map[ele?.id] = ele;
		});
		return map;
	}, [stores]);

	const vendorIdMap = useMemo(() => {
		const map = {};
		vendorsList?.forEach((ele) => {
			map[ele?.id] = ele;
		});
		return map;
	}, [vendorsList]);

	const handleStatus = async (data, rejectionReason, type) => {
		let status = '';
		if (data?.transactionStatus === 'APPROVAL_PENDING_MANAGER') {
			status = 'APPROVAL_PENDING_FINANCE';
		}
		if (data?.transactionStatus === 'APPROVAL_PENDING_FINANCE') {
			// if (paidPaymentModes?.includes(data?.extraData?.paymentMode)) {
			// status = 'PAID';
			// } else {
			// status = 'UNPAID';
			// }
			if (data?.extraData?.isPaid) {
				status = 'PAID';
			} else {
				status = 'UNPAID';
			}
		}
		if (type === 'rejection') {
			status = 'REJECTED';
		}
		if (type === 'cancelation') {
			status = 'CANCELLED';
		}
		try {
			const responseData =
				await inventoryAnalyticsServices.updateInventoryTransaction({
					params: {
						transactionId: data?.id,
					},
					data: {
						status,
						type: 'BILL',
						// subType: ''
						nextFlowLink: `${window?.location?.origin}${urls.EXTENSION}${urls.PETTY_CASH}?clientUtilityId=${data?.clientTransactionId}`,
						...(type === 'rejection' && {
							rejectionReason,
						}),
					},
				});
			if (responseData?.statusCode === 200) {
				setUpdate((prev) => {
					return prev + 1;
				});
				notificationServices?.generateNotification({
					type: 'success',
					message: responseData?.message,
				});
				togglePOItemsModal(false, {});
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		}
	};

	const getTaxFromStr = (tt) => {
		let num = 0;
		let taxStr = tt;
		if (!taxStr) return num;
		if (taxStr?.includes?.('%')) {
			taxStr = taxStr?.replace('%', '');
			if (!Number.isNaN(taxStr)) {
				num = Number(taxStr);
			}
		}
		return num;
	};

	const handleEditClick = (item) => {
		const redirectUrl = `${urls.EXTENSION}${urls.PETTY_CASH}/add?id=${item?.id}&edit=true`;
		window.open(redirectUrl);
	}

	// The API re-opens an edited expense for manager approval, so Edit is offered only
	// where it accepts one: an Expense (not Income) still pending manager approval, or
	// sent back rejected. Level gate mirrors the create button below - L1/L3 approve,
	// they don't author.
	const EDITABLE_STATUSES = ['REJECTED', 'APPROVAL_PENDING_MANAGER'];
	const canEditExpense = (item) => {
		return (
			item?.extraData?.paymentType === 'Expense' &&
			EDITABLE_STATUSES.includes(item?.transactionStatus) &&
			level !== 1 &&
			level !== 3
		);
	};

	const specialItems = {
		'Payment Type': (extraData) => {
			return extraData?.paymentType ?? '-';
		},
		'Client Transaction Id': (clientTransactionId, item) => {
			if (!clientTransactionId) {
				return '-';
			}
			return (
				<div
					role='button'
					tabIndex={0}
					style={{
						cursor: 'pointer',
						color: '#2563eb',
						textDecoration: 'underline',
						textAlign: 'left',
					}}
					onClick={() => {
						handleViewClick(item);
					}}
				>
					{clientTransactionId}
				</div>
			);
		},
		'Expense tax slab': (id) => {
			const currentAdHoc = pettyCashList?.find((ele) => {
				return ele?.id === id;
			});
			if (currentAdHoc?.extraData?.paymentType !== 'Expense') {
				return '-';
			}
			const taxStr = currentAdHoc?.extraData?.taxSlab;
			return taxStr;
		},
		'Expense tax amount': (id, showRs = true) => {
			const currentAdHoc = pettyCashList?.find((ele) => {
				return ele?.id === id;
			});
			if (currentAdHoc?.extraData?.paymentType !== 'Expense') {
				return '-';
			}
			const taxStr = currentAdHoc?.extraData?.taxSlab;
			const tax = getTaxFromStr(taxStr);
			const beforeTax =
				currentAdHoc?.finalTransactionAmount / (1 + tax / 100);
			const value = (
				currentAdHoc?.finalTransactionAmount - beforeTax
			).toFixed(2);
			return `${showRs ? '\u20B9' : ''}${value}`;
		},
		'Expense Sub Total': (id, showRs = true) => {
			const currentAdHoc = pettyCashList?.find((ele) => {
				return ele?.id === id;
			});
			if (currentAdHoc?.extraData?.paymentType !== 'Expense') {
				return '-';
			}
			const taxStr = currentAdHoc?.extraData?.taxSlab;
			const tax = getTaxFromStr(taxStr);
			const beforeTax =
				currentAdHoc?.finalTransactionAmount / (1 + tax / 100);
			const value = beforeTax.toFixed(2);
			return `${showRs ? '\u20B9' : ''}${value}`;
		},
		'Expense Total': (id, showRs = true) => {
			const currentAdHoc = pettyCashList?.find((ele) => {
				return ele?.id === id;
			});
			if (currentAdHoc?.extraData?.paymentType !== 'Expense') {
				return '-';
			}
			return `${showRs ? '\u20B9' : ''}${(
				currentAdHoc?.finalTransactionAmount ?? 0
			).toFixed(2)}`;
		},
		'Income Total': (id) => {
			const currentAdHoc = pettyCashList?.find((ele) => {
				return ele?.id === id;
			});
			if (currentAdHoc?.extraData?.paymentType !== 'Income') {
				return '-';
			}
			return `\u20B9${currentAdHoc?.finalTransactionAmount}`;
		},
		'Payment Mode': (extraData) => {
			return (
				<div
					style={{
						textAlign: 'center',
					}}
				>
					{extraData?.paymentMode ?? '-'}
				</div>
			);
		},
		Status: (_, item) => {
			if (item?.transactionStatus === 'REJECTED') {
				const rejectionReason = item?.extraData?.rejectionReason;
				return (
					<div className={styles.rejected}>
						<p>{item?.transactionStatus?.split('_')?.join(' ')}</p>
						{rejectionReason && (
							<p style={{ fontSize: '0.75rem', color: '#b91c1c', marginTop: '2px' }}>
								{rejectionReason}
							</p>
						)}
					</div>
				);
			}
			return item?.transactionStatus?.split('_')?.join(' ');
		},
		'Payment By': (_, item) => {
			return item?.extraData?.isPaid ? 'Submitter' : 'Finance';
		},
		'Transaction Date': (date) => {
			return moment(date)?.format('DD-MM-YYYY');
		},
		'Due Date': (date) => {
			if (!date) return '-';
			return moment(date)?.format('DD-MM-YYYY');
		},
		'Created At': (date) => {
			if (!date) return '-';
			return moment(date)?.format('DD-MM-YYYY');
		},
		'Reference doc': (uploadedDoc) => {
			if (!uploadedDoc) return '-';
			return (
				<div
					className={styles.reference}
					onClick={() => {
						if (uploadedDoc) {
							window.open(uploadedDoc, '_blank');
						} else {
							notificationServices.generateNotification({
								type: 'error',
								message: 'No Reference Uploaded',
							});
						}
					}}
				>
					<Download className={styles.icon} />
				</div>
			);
		},
		'Ref. Number': (extraData) => {
			return extraData?.referenceNumber;
		},
		Actions: (id) => {
			const item = pettyCashList?.find((ele) => {
				return ele?.id === id;
			});
			return (
				<div className={styles.btns}>
					{canEditExpense(item) ? (
						<Button
							variant='outlined'
							className='bg-slate-400 text-white hover:bg-slate-600 rounded-md px-3 py-1 font-medium'
							onClick={() => {
								handleEditClick(item);
							}}
							fullWidth
						>
							Edit
						</Button>
					) : null}
					{(item?.transactionStatus === 'APPROVAL_PENDING_MANAGER') &&
						levels.includes(level) ? (
						<Button
							variant='contained'
							color='primary'
							onClick={() => {
								handleApproveClick(item);
								// handleApproval('APPROVAL_PENDING_MANAGER', id);
							}}
							fullWidth
						>
							Manager Approval
						</Button>
					) : null}
					{(item?.transactionStatus === 'APPROVAL_PENDING_FINANCE') &&
						levels.includes(level) && (isInternal || Object?.values?.(userRolesDict ?? {}).includes('Finance')) ? (
						<Button
							variant='contained'
							color='primary'
							onClick={() => {
								handleApproveClick(item);
								// handleApproval('APPROVAL_PENDING_FINANCE', id);
							}}
							fullWidth
						>
							Finance Approval
						</Button>
					) : null}
					{item?.transactionStatus === 'APPROVAL_PENDING_MANAGER' ? (
						<Button
							variant='outlined'
							color='error'
							onClick={() => {
								toggleAlert(true, {
									heading: `Cancel Ad-Hoc Expense/Income - ${item?.clientTransactionId}`,
									handleConfirm: () => {
										handleStatus(item, id, 'cancelation');
										toggleAlert(false);
									},
									colorReverse: false,
									cancelText: 'No',
									confirmText: 'Yes',
									message: `Are you sure you want to Cancel Entry: ${item?.clientTransactionId || ''
										}?`,
									width: '28rem',
								});
							}}
							fullWidth
						>
							Cancel
						</Button>
					) : (
						!canEditExpense(item) && '-'
					)}
				</div>
			);
		},
	};

	function handleApproveClick(item) {
		togglePOItemsModal(true, {
			heading: `Ad-Hoc Expense/Income #${item?.clientTransactionId ?? item?.id
				}`,
			...item,
			isApprove: true,
			advanceBill: true,
			approvalText: 'I have checked the Ad-Hoc Expense/Income Bill.',
			showTotal: false,
			showPdf: true,
			showPoDetails: true,
			width: '90%',
			height: '90%',
			txnHeader: {
				show: item?.extraData?.isPaid,
				heading: 'Transaction Already PAID',
				helper: 'Post Approval, a payment record will be generated',
			},
			transactionData: {
				'Client Transaction ID': item?.clientTransactionId,
				'Payment Type': item?.extraData?.paymentType,
				Store: item?.storeName,
				'Payment Mode': item?.extraData?.paymentMode,
				Vendor: item?.vendorName,
				...(item?.extraData?.paymentType !== 'Income' && {
					'Expense Sub Total': specialItems['Expense Sub Total']?.(
						item.id,
						true
					),
					'Expense Tax Slab': specialItems['Expense tax slab']?.(
						item.id,
						true
					),
					'Expense Tax Amount': specialItems['Expense tax amount']?.(
						item.id,
						true
					),
				}),
				'Transaction Amount': `\u20B9${item?.finalTransactionAmount}`,
				'Transaction Date': moment(item?.transactionDate)?.format(
					'DD-MM-YYYY'
				),
				'Due Date': moment(item?.dueDate)?.format('DD-MM-YYYY'),
				Status: item?.transactionStatus === 'REJECTED' && item?.extraData?.rejectionReason
					? `${item?.transactionStatus?.split('_')?.join(' ')} (${item?.extraData?.rejectionReason})`
					: item?.transactionStatus?.split('_')?.join(' '),
				'Ref. Number': item?.extraData?.referenceNumber ?? '-',
				Description: item?.description ?? '-',
				Category: item?.category ?? '-',
			},
			hideItems: true,
			excludedColumns: ['Used For', 'Last Purchase Rate 1', 'Last Purchase Rate 2', 'Last Purchase Rate 3', 'Recommended Quantity', 'Standard PO Qty'],
		});
	}

	const fetchPettyCashList = async (req, isRefresh = false) => {
		setIsRefresh(isRefresh);
		setIsLoading(true);
		const searchFilterPayload = {};
		searchFilters?.forEach((ele) => {
			if (ele?.value) {
				searchFilterPayload[ele?.id] = ele?.value;
			}
		});
		setFilters(req);
		const filters = {
			subTypes: req?.type === 'ALL' || req?.type === null ? ['EXPENSE', 'INCOME'] : [req?.type],
			status: req?.status,
			vendors: req?.vendors?.id,
			storeId: req?.store?.id === -999 ? null : req?.store?.id ?? null,
		};
		if (req?.dateRange?.active) {
			filters.dateRangeFilter = {
				timeType: req?.timeType?.value,
				from: moment(req?.dateRange?.from).format('YYYY-MM-DD'),
				to: moment(req?.dateRange?.to).format('YYYY-MM-DD'),
			};
		}
		try {
			const response =
				await inventoryAnalyticsServices.fetchInvTransRecord({
					req: {
						data: {
							type: 'BILL',
							filters,
							...searchFilterPayload,
						},
					},
				});
			if (response?.statusCode === 200) {
				// setSelectedStore(store);
				setPettyCashList(response?.data);
				// setLatestVersion(responseData?.data?.latestVersion);
			}
		} catch (error) {
			// console.log('Error', error);
		} finally {
			setIsLoading(false);
		}
	};

	const handleAddClick = () => {
		const redirectUrl =
			navSelectedStore?.value?.id !== -999
				? `${urls.EXTENSION}${urls.PETTY_CASH}/add?toStore=${navSelectedStore?.value?.id}`
				: `${urls.EXTENSION}${urls.PETTY_CASH}/add`;
		history.push(redirectUrl);
	};

	const handleViewClick = (item) => {
		togglePOItemsModal(true, {
			heading: `Ad-Hoc Expense/Income #${item?.clientTransactionId ?? item?.id
				}`,
			...item,
			isApprove: false,
			advanceBill: false,
			approvalText: 'I have checked the Ad-Hoc Expense/Income Bill.',
			showTotal: false,
			showPdf: true,
			showPoDetails: true,
			width: '90%',
			height: '90%',
			transactionData: {
				'Client Transaction ID': item?.clientTransactionId,
				'Payment Type': item?.extraData?.paymentType,
				Store: item?.storeName,
				'Payment Mode': item?.extraData?.paymentMode,
				Vendor: item?.vendorName,
				'Transaction Amount': `\u20B9${item?.finalTransactionAmount}`,
				'Transaction Date': moment(item?.transactionDate)?.format(
					'DD-MM-YYYY'
				),
				'Due Date': moment(item?.dueDate)?.format('DD-MM-YYYY'),
				Status: item?.transactionStatus === 'REJECTED' && item?.extraData?.rejectionReason
					? `${item?.transactionStatus?.split('_')?.join(' ')} (${item?.extraData?.rejectionReason})`
					: item?.transactionStatus?.split('_')?.join(' '),
				'Ref. Number': item?.extraData?.referenceNumber ?? '-',
				Description: item?.description ?? '-',
				Category: item?.category ?? '-',
			},
			hideItems: true,
			excludedColumns: ['Used For', 'Last Purchase Rate 1', 'Last Purchase Rate 2', 'Last Purchase Rate 3', 'Recommended Quantity', 'Standard PO Qty'],
		});
	};

	const onExportClick = () => {
		const headers = TABLE_COLUMNS?.filter((ele) => {
			return ![]?.includes(ele?.title);
		})?.map((ele) => {
			return ele?.title;
		});
		headers.splice(14, 0, 'Rejection Reason');
		headers.splice(18, 1);
		headers.splice(18, 0, ...['IGST amount', 'CGST amount', 'SGST amount']);
		headers.splice(999, 0, ...['store gst', 'vendor gst']);
		const totalValues = [];
		pettyCashList?.forEach((pettyCashItem) => {
			if (pettyCashItem?.transactionStatus !== 'CANCELLED') {
				totalValues?.push([
					pettyCashItem?.id,
					pettyCashItem?.extraData?.paymentType,
					pettyCashItem?.storeName,
					pettyCashItem?.category ?? '-',
					pettyCashItem?.extraData?.paymentMode,
					pettyCashItem?.vendorName,
					pettyCashItem?.clientTransactionId,
					pettyCashItem?.transactionStatus,
					pettyCashItem?.initiatedByUserDisplayName,
					moment(pettyCashItem?.createdAt).format('YYYY-MM-DD'),
					(pettyCashItem?.extraData?.isPaid
						? 'Submitter'
						: 'Finance') ?? '-',
					pettyCashItem?.transactionDate,
					pettyCashItem?.dueDate,
					pettyCashItem?.l1ActionByUserDisplayName,
					pettyCashItem?.extraData?.rejectionReason ?? '-',
					pettyCashItem?.l2ActionByUserDisplayName,
					...(pettyCashItem?.extraData?.paymentType === 'Expense'
						? [
							specialItems['Expense Sub Total']?.(
								pettyCashItem.id,
								false
							),
						]
						: ['-']),
					...(pettyCashItem?.extraData?.paymentType === 'Expense'
						? [specialItems['Expense tax slab']?.(pettyCashItem.id)]
						: ['-']),
					...(pettyCashItem?.extraData?.paymentType === 'Expense' &&
						!pettyCashItem?.extraData?.isSameState
						? [
							specialItems['Expense tax amount']?.(
								pettyCashItem.id,
								false
							),
						]
						: [0]),
					...(pettyCashItem?.extraData?.paymentType === 'Expense' &&
						pettyCashItem?.extraData?.isSameState
						? [
							(
								Number(
									specialItems['Expense tax amount']?.(
										pettyCashItem.id,
										false
									)
								) / 2
							).toFixed,
						]
						: [0]),
					...(pettyCashItem?.extraData?.paymentType === 'Expense' &&
						pettyCashItem?.extraData?.isSameState
						? [
							(
								Number(
									specialItems['Expense tax amount']?.(
										pettyCashItem.id,
										false
									)
								) / 2
							).toFixed,
						]
						: [0]),
					...(pettyCashItem?.extraData?.paymentType === 'Expense'
						? [pettyCashItem?.finalTransactionAmount]
						: ['-']),
					...(pettyCashItem?.extraData?.paymentType === 'Income'
						? [pettyCashItem?.finalTransactionAmount]
						: ['-']),
					pettyCashItem?.extraData?.referenceNumber ?? '-',
					pettyCashItem?.uploadedDoc,
					pettyCashItem?.extraData?.paymentType === 'Expense'
						? storeIdMap?.[pettyCashItem?.storeId]?.gstNumber ?? '-'
						: '-',
					pettyCashItem?.extraData?.paymentType === 'Expense'
						? vendorIdMap?.[pettyCashItem?.vendorId]?.gstin ?? '-'
						: '-',
				]);
			}
		});
		const fileName = getFileName(filters);
		handleExcelDownload(headers, totalValues, fileName);
	};

	const getRowStyles = (status) => {
		return styles?.[status];
	};

	const footerComponent = () => {
		return (
			<div className={styles.footer}>
				<div className={styles.sub_type}>
					<label>Ad-Hoc Type:</label>
					<SelectPicker
						data={['ALL', 'EXPENSE', 'INCOME']?.map((ele) => {
							return {
								label: ele,
								value: ele,
							};
						})}
						value={subType}
						onChange={(subTypeVal) => {
							setSubtype(subTypeVal);
						}}
						cleanable={false}
						searchable={false}
						style={{
							width: 150,
						}}
						placeholder='Select Ad-Hoc'
					/>
				</div>
			</div>
		);
	};

	const filtersInfo = {
		header: {
			date: false,
			statusAndTypes: false,
			store: false,
		},
		dateRange: {
			show: true,
		},
		filteredStore: {
			text: 'Store',
			show: true,
		},
		vendor: {
			text: 'Vendor',
			show: true,
		},
		status: {
			text: 'Status',
			show: true,
		},
		type: {
			text: 'Ad-Hoc Type',
			show: true,
			list: [
				{
					label: 'ALL',
					type: 'ALL',
				},
				{
					label: 'EXPENSE',
					type: 'EXPENSE',
				},
				{
					label: 'INCOME',
					type: 'INCOME',
				},
			],
		},
		timeType: {
			text: 'Date Time Type',
			show: true,
		},
	};

	const exportInfo = {
		showExportBtn: true,
	};

	const idSearch = async () => {
		setIsLoading(true);
		const filters = {
			...(search?.value === 'id' && { id: Number(search?.searchValue) }),
			...(search?.value === 'clientTransactionId' && { clientTransactionId: search?.searchValue }),
		};
		try {
			const response =
				await inventoryAnalyticsServices.fetchInvTransRecord({
					req: {
						data: {
							type: 'BILL',
							search: filters,
						},
					},
				});
			if (response?.statusCode === 200) {
				setPettyCashList(response?.data);
			}
		} catch (error) {
		} finally {
			setIsLoading(false);
		}
	}

	useEffect(() => {
		if (search?.keyPress && search?.searchValue?.trim() === '') {
			fetchPettyCashList(filters);
		}
	}, [search?.searchValue]);

	const dropDownItems = [
		{
			label: 'ID',
			value: 'id',
			placeholder: 'Search by ID',
			getData: true,
		},
		{
			label: 'Client Transaction ID',
			value: 'clientTransactionId',
			placeholder: 'Search by Client Transaction ID',
			getData: true,
		},
	];

	const handleCall = (e) => {
		if (e.key === 'Enter') {
			idSearch();
		}
	};

	return (
		<div className={styles.root}>
			<BackdropLoader isLoading={isLoading} showProgress />
			<POItemsModal
				handleConfirm={handleStatus}
				handleReject={(data, rejectionReason) => {
					handleStatus(data, rejectionReason, 'rejection');
				}}
			/>
			<ImagesFinder
				onSubmit={fetchPettyCashList}
				statusList={statusList}
				timeTypeArray={timeTypeArr}
				update={update}
				externalFilters={searchFilters}
				filtersInfo={filtersInfo}
				exportInfo={exportInfo}
			/>

			<div className='flex flex-col gap-2 w-full'>
				<div className='flex justify-between m-4 '>
					<span className='font-bold text-[16px]'>Ad-Hoc Expense/Income</span>
					{level !== 1 && level !== 3 && (
						<Button
							onClick={handleAddClick}
							className='bg-yellow-400 hover:bg-yellow-500 rounded-md flex items-center justify-center gap-2 text-black'
						>
							+ Add Ad-Hoc Expense/Income
						</Button>
					)}
				</div>
				<div className='flex gap-4 w-full justify-start items-center py-1'>
					<div className='w-[82%]'>
						<GlobalSearch
							dropDownOptions={dropDownItems}
							setSelectedValue={setSearch}
							handleValue={handleCall}
							isRefresh={isRefresh}
						/>
					</div>
					<Tooltip title='Refresh Ad-Hoc Expense/Income'>
						<RefreshCcw className='size-5 cursor-pointer' onClick={() => {
							fetchPettyCashList(filters, true);
						}} />
					</Tooltip>
					<Button
						onClick={() => {
							toggleFiltersDrawer(true, {
								exportFrontend: true,
								handleExportFrontend: onExportClick,
							});
						}}
						className='flex justify-center gap-2 px-4 py-2 text-white bg-teal-600 border border-gray-300 rounded-md hover:bg-teal-700'
					>
						<span className='text-nowrap'>Filter & Export</span>
						<Filter className='size-4' />
					</Button>
				</div>
			</div>
			{filtersInfoChip(filtersInfo, filters)}
			<div className={styles.list}>
				<ListTable
					colMap={COLMAP}
					columns={TABLE_COLUMNS}
					data={pettyCashList?.map((ele) => {
						return {
							...ele,
							rowStyles: getRowStyles(ele?.transactionStatus),
						};
					})}
					actions={getActionColumn(BASE_COLUMN, ADDITIONAL_COLUMN, level)}
					special={specialItems}
					handleViewClick={handleViewClick}
					allowExport={false}
				/>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	const { navState, userPermissions } = state.navigation;
	const stores = state?.form?.STORES?.data?.LIST;
	const { LIST: vendorsList } = state.form.ALL_VENDORS.data;
	const { userList } = state?.auth;

	return {
		stores,
		vendorsList,
		navState,
		userPermissions,
		userList,
	};
};

const mapDispatchToProps = {
	togglePOItemsModal: modalActions.togglePOItemsModal,
	toggleAlert: modalActions.toggleAlert,
	fetchAllVendors: formActions.gateway,
	fetchStoresList: formActions.gateway,
	fetchUserList: authActions?.fetchUserList,
	toggleFiltersDrawer: drawerActions.toggleFiltersDrawer,
};

export default connect(mapStateToProps, mapDispatchToProps)(PettyCash);
